import FsLightbox from 'fslightbox-react';
import Image from '@jetshop/ui/Image';
import { styled } from 'linaria/react';
import React, { useState } from 'react';

const OuterWrapper = styled('div')`
  padding-right: 30px;
  .fslightbox-source-inner {
    overflow-y: scroll;
    height: 100vh;
    overflow-x: hidden;
  }
  .fslightbox-toolbar-button {
    :first-child {
      display: none !important;
    }
  }
  .fslightbox-source {
    width: 100vw !important;
    height: auto !important;
  }
`;
const ImageGridWrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  position: relative;

  &.single-image {
    display: block;
  }

  > * {
    cursor: zoom-in;
  }

  .fav-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
`;

const BottomImageWrapper = styled('div')`
  display: grid;
  margin-top: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  position: relative;

  > * {
    cursor: zoom-in;
  }
`;

export default function ImageGrid({
  images,
  badges,
  product,
  selectedVariation
}) {
  const [toggler, setToggler] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const gridImages = [];
  const bottomImages = [];

  let sources = [];
  const imageSizes = [1, 1, 1, 300, 600];

  for (let i = 0; i < images.length; i++) {
    sources.push(images[i].url);
  }

  if (images.length > 4) {
    gridImages.push(images.slice(0, 4));
    bottomImages.push(images.slice(4));
  }

  if (images.length <= 4) {
    gridImages.push(images.slice(0, 4));
  }

  return (
    <OuterWrapper>
      <ImageGridWrapper className={gridImages[0]?.length < 2 && 'single-image'}>
        {gridImages[0]?.map((image, index) => (
          <Image
            key={index}
            src={image.url}
            alt={image.alt}
            aspect="1:1"
            sizes={imageSizes}
            critical
            onClick={() => {
              setImageIndex(index);
              setToggler(!toggler);
            }}
          />
        ))}
      </ImageGridWrapper>
      {bottomImages[0]?.length > 0 && (
        <BottomImageWrapper>
          {bottomImages[0].map((image, index) => (
            <Image
              key={index}
              src={image.url}
              alt={image.alt}
              sizes={imageSizes}
              aspect="1:1"
              onClick={() => {
                setImageIndex(index + 4);
                setToggler(!toggler);
              }}
            />
          ))}
        </BottomImageWrapper>
      )}
      <FsLightbox
        toggler={toggler}
        type="image"
        sources={sources}
        sourceIndex={imageIndex}
      />
    </OuterWrapper>
  );
}
